import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken} from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
// import $ from "jquery";
import PropTypes from 'prop-types';

import {
  MenuItem,
} from '@mui/material';


const DailyProductionReports = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [dataacaliber, setDataacaliber] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  const [formData, setFormData] = useState({
    season_id:season_id,
    start_date: '',
    end_date: ''
  });

 
   const handleChange = (e) => {
     const { name, value } = e.target;
     setFormData({ ...formData, [name]: value });
   };
   const handleSubmit = (e) => {
     e.preventDefault();
 
     axios
     .post("/daily-production-reports/listing-groupby-caliber", formData, {
       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
     }) .then((response) => {
    
 
       if (response.data.code === 200) {
 
        var all_calibers = response.data.data.reports_groupby_calibres;

        console.log("all_calibers");
        console.log(all_calibers);


        const totalQuantity2 = all_calibers.reduce((sum, item) => sum + Number(item.quantity), 0);

        setTotalQuantity(totalQuantity2);

        const sortedData = all_calibers.sort((a, b) => {
          const isNumA = !isNaN(a.calibre);
          const isNumB = !isNaN(b.calibre);
        
          if (isNumA && isNumB) {
            // Both are numbers, sort numerically
            return Number(a.calibre) - Number(b.calibre);
          } else if (isNumA) {
            // A is a number, B is not → A comes first
            return -1;
          } else if (isNumB) {
            // B is a number, A is not → B comes first
            return 1;
          } else {
            // Both are non-numeric, sort alphabetically
            return a.calibre.localeCompare(b.calibre, undefined, { numeric: true });
          }
        });

      
        setDataacaliber(sortedData);
 
       } 
       else {
          //setBackendErrors(response.data.error);
       }
     })
     .catch((error) => {
       console.log(error);
      // actions.setSubmitting(false);
     });
   
   }
  useEffect(() => {
        setPermission(FindModuleById(61)); 
console.log(permission);






      axios.post("/daily-production-reports/listing",formData,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
      .then((response) => {
        setData(response.data.data.reports);
      })  .catch((error) => {
        console.log(error);
      });

      axios.post("/daily-production-reports/listing-groupby",formData,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
      .then((response) => {
        console.log(response.data.data.reports_groupby);
        setDataa(response.data.data.reports_groupby);
      })  .catch((error) => {
        console.log(error);
      });
      axios.post("/daily-production-reports/listing-groupby-caliber",formData,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
      .then((response) => {
       
        var all_calibers = response.data.data.reports_groupby_calibres;

        console.log("all_calibers");
        console.log(all_calibers);


        const totalQuantity2 = all_calibers.reduce((sum, item) => sum + Number(item.quantity), 0);

        setTotalQuantity(totalQuantity2);

        const sortedData = all_calibers.sort((a, b) => {
          const isNumA = !isNaN(a.calibre);
          const isNumB = !isNaN(b.calibre);
        
          if (isNumA && isNumB) {
            // Both are numbers, sort numerically
            return Number(a.calibre) - Number(b.calibre);
          } else if (isNumA) {
            // A is a number, B is not → A comes first
            return -1;
          } else if (isNumB) {
            // B is a number, A is not → B comes first
            return 1;
          } else {
            // Both are non-numeric, sort alphabetically
            return a.calibre.localeCompare(b.calibre, undefined, { numeric: true });
          }
        });

      
        setDataacaliber(sortedData);

      })  .catch((error) => {
        console.log(error);
      });
   
   
  }, []);

  
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/daily-production-reports/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/production-daily-reports";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const ShiftDateCell = ({ row }) => (
    <a href={`/production-daily-reports-groupbyfilters/${row.original.date}_${row.original.location}_${row.original.shift}`} className="">
      {row.original.date}
    </a>
  );
  
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        date: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  
  // ✅ Location Cell Component
  const LocationCell = ({ row }) => (
    <a href={`/production-daily-reports-groupbyfilters/${row.original.date}_${row.original.location}_${row.original.shift}`} className="">
      {row.original.location_name || ''}
    </a>
  );
  
  LocationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        date: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
        location_name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };
  
  // ✅ Shift Cell Component
  const ShiftCell = ({ row }) => (
    <a href={`/production-daily-reports-groupbyfilters/${row.original.date}_${row.original.location}_${row.original.shift}`} className="">
      {row.original.shift}
    </a>
  );
  
  ShiftCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        date: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  
  // ✅ Total Consumption Cell Component
  const TotalConsumptionCell = ({ row }) => (
    <span>{row.original.sum_net_weight.toFixed(2)} (KG)</span>
  );
  
  TotalConsumptionCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const columnss = [
 
    {
      header: 'Shift Date',
      accessorFn: (row) => row.date,
      Cell: (props) => <ShiftDateCell {...props} />, // ✅ Use the new component
    },
    {
      header: 'Location',
      accessorFn: (row) => row.location_name || '',
      Cell: (props) => <LocationCell {...props} />, // ✅ Use the new component
    },
    {
      header: 'Shift',
      accessorFn: (row) => row.shift,
      Cell: (props) => <ShiftCell {...props} />, // ✅ Use the new component
    },
    {
      accessorKey: 'total_consumption',
      header: 'Total Consumption',
    },
    // {
    //   accessorKey: 'NumberOfFinishedPallets',
    //   header: 'Number Of Finished Pallets',
    // },
    // {
    //   accessorKey: 'NumberOfPending_pallets',
    //   header: 'Number Of Reste Pallets',
    // },
    {
      accessorKey: 'NumberOfSmall_calibers',
      header: 'Small Calibers',
    },
    // {
    //   header: 'Small Calibers %',
    //   accessorFn: (row) => `${row.NumberOfSmall_calibers_percentage.toFixed(2)}% `,
    // },
    {
      accessorKey: 'return_total',
      header: 'Return Total',
    },
    {
      accessorKey: 'decay_total',
      header: 'Decay Total',
    },
    // {
    //   header: 'Decay %',
    //   accessorFn: (row) => `${row.decay_percentage.toFixed(2)}% `,
    // },
    {
      accessorKey: 'finished_products_net_weight',
      header: 'Finished Products Net Weight',
    },
    {
      accessorKey: 'Pending_pallet_net_weight',
      header: 'Pending / Raste Pallet Net Weight',
    },
  ];
  
  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
// const calibreCell = ({ row }) => {
//   const queryString = objectToQueryString(formData); 
// (
 
//   <a href={`/production-daily-reports-groupbycaliber/${row.original.calibre}?${queryString}`}>
//     {row.original.calibre}
//   </a>
// )};
const calibreCell = ({ row }) => {
  const queryString = objectToQueryString(formData); // Make sure formData is in scope

  return (
    <a href={`/production-daily-reports-groupbycaliber/${row.original.calibre}?${queryString}`}>
      {row.original.calibre}
    </a>
  );
};

// ✅ PropTypes for calibreCell
calibreCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      calibre: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Reusable row prop type definition
const rowPropTypes = PropTypes.shape({
  original: PropTypes.shape({
    calibre: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
});

const PercentageCell = ({ row, totalQuantity }) => {
  const quantity = row.original.quantity;
  const totalNetWeight = totalQuantity > 0 ? (quantity / totalQuantity) * 100 : 0;

  return <span>{totalNetWeight.toFixed(4)}%</span>;
};

// ✅ PropTypes for PercentageCell
PercentageCell.propTypes = {
  row: rowPropTypes.isRequired,
  totalQuantity: PropTypes.number.isRequired,
};

const PercentageColumnCell = ({ row, totalQuantity }) => (
  <PercentageCell row={row} totalQuantity={totalQuantity} />
);

// ✅ Explicitly define PropTypes for PercentageColumnCell (Fix for row missing validation)
PercentageColumnCell.propTypes = {
  row: rowPropTypes.isRequired,
  totalQuantity: PropTypes.number.isRequired,
};

const columnss_caliber =  [
  {
    header: 'Calibre',
    accessorFn: (row) => `${row.calibre} `,
    Cell: calibreCell,
  },
  {
    accessorKey: 'number_of_pallets',
    header: 'Number Of Pallets',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  {
    header: 'Percentage',
    accessorFn: (row) => (totalQuantity > 0 ? ((row.quantity / totalQuantity) * 100).toFixed(4) : '0.0000'),
    Cell: (props) => <PercentageColumnCell {...props} totalQuantity={totalQuantity} />,
  },
];

// ✅ Validate totalQuantity
columnss_caliber.propTypes = {
  totalQuantity: PropTypes.number.isRequired,
};

  const ReportLink = ({ row, children }) => (
    <a href={`/production-daily-reports-view/${row.original.id}`} className="">
      {children}
    </a>
  );
  
  ReportLink.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        date: PropTypes.string.isRequired, // Ensure date is validated
      }).isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
  };
  
  // ✅ Separate DateCell component to fix missing row validation
  const DateCell = ({ row }) => <ReportLink row={row}>{row.original.date}</ReportLink>;
  
  DateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        date: PropTypes.string.isRequired, // Ensure date is validated
      }).isRequired,
    }).isRequired,
  };
  
  const columns = [
    {
      header: 'Date',
      accessorFn: (row) => row.date,
      Cell: (props) => <DateCell {...props} />, // ✅ Use the new component
    },
    {
      header: 'Location',
      accessorFn: (row) => row.location_name?.title ?? '',
    },
    {
      accessorKey: 'shift',
      header: 'Shift',
    },
    {
      accessorKey: 'raw_material_consumption',
      header: 'Consumption',
    },
    {
      accessorKey: 'decay',
      header: 'Decay',
    },
    {
      header: 'Finished Products Net Weight',
      accessorFn: (row) => `${row.finished_products_net_weight} KG`,
    },
    {
      accessorKey: 'pending_pallets',
      header: 'Pending Pallets',
    },
    {
      accessorKey: 'return',
      header: 'Return',
    },
    {
      accessorKey: 'small_calibers',
      header: 'Small Calibers',
    },
    {
      header: 'Report Status',
      accessorFn: (row) => row.report_status_title?.title ?? '',
    },
    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby
          ? `${row.createdby.first_name ?? ''} ${row.createdby.last_name ?? ''}`.trim()
          : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby
          ? `${row.updatedby.first_name ?? ''} ${row.updatedby.last_name ?? ''}`.trim()
          : '',
    },
  ];

  const editItem = (item)=>{
    window.location.href = "/production-daily-reports-edit/"+item;
  }

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    // delete backendErrors[Input_name];
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Production Daily Reports</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Production Daily Reports
                    </li>
                  </ul>
                </div>
                <div className="col-auto">
                {permission && permission.add == 1 && (
                  <Link
                      to="/production-daily-reports-add"
                      className="btn btn-primary me-1"
                    >
                  <i className="fas fa-plus"></i>
                </Link>
                )}
                  
                </div>
              </div>
            </div>

          

     


         <div className="row">
              <div className="col-md-12">
                
              <section className="comp-section">
       
        
            <div className="row">
            <div className="col-md-12">
                <div className="card bg-white">
                {permission && permission.list == 1 && (
                <div className="card-body">
                    <ul className="nav nav-tabs nav-tabs-bottom">
                    <li className="nav-item">
                        <a className="nav-link active" href="#bottom-tab1" data-bs-toggle="tab">Calculated Daily Reports</a>                                  
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#bottom-tab2" data-bs-toggle="tab">Manual Daily Reports</a>                                   
                    </li>  
                    <li className="nav-item">
                        <a className="nav-link" href="#bottom-tab3" data-bs-toggle="tab">Production Daily Reports Group By Caliber</a>                                   
                    </li>    
                                            
                    </ul>
                    <div className="tab-content">
                    <div className="tab-pane show active" id="bottom-tab1">
                    <div className="row"   id="listing-followup">
                      <div className="col-sm-12">
                        <div className="card card-table">
                          <div className="card-body">

                          <div className="table-responsive">
                                    <MaterialReactTable columns={columnss} data={dataa} 
                                        enableColumnOrdering
                                        enablePinning
                                      />
                                    </div>
                             
                          </div>
                        </div>
                      </div>
                    </div>
                      
                      </div>       

                                               
                    <div className="tab-pane" id="bottom-tab3">
                          <div className="row"  id="listing-followup-groupby" >
            
                                <div className="col-sm-12" >
                                  <div className="card-body p-10">
                                                  <form onSubmit={handleSubmit}>
                                                  <div className="row">
                                                 
                                                   
                                                  
                                                    <div className="col-md-2">
                                                      <div className="form-group">
                                                        <label>Start Date:</label>
                                                        <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                                                  handleChange(e);
                                                                  customHandleInput(e);
                                                                }}  />
                                                      </div>
                                                    </div>
                                                  
                                                    <div className="col-md-2">
                                                      <div className="form-group">
                                                        <label>End Date:</label>
                                                        <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                                                  handleChange(e);
                                                                  customHandleInput(e);
                                                                }}  />
                                                      </div>
                                                    </div>
                                                  
                                                    <div className="col-md-2">
                                                      <div className="pt-4 mt-2">
                                                        <button type="submit" className="btn btn-primary">
                                                          Filter
                                                        </button>
                                                        &nbsp;&nbsp;
                                                        <a href="/production-daily-reports" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                                  
                                  
                                                      </div>
                                                    </div>
                                                  </div>
                                                  </form>
                                                  
                                                </div>
                                <div className="card card-table">
                                  <div className="card-body">
                                     
                                  <div className="table-responsive">

                                      <MaterialReactTable columns={columnss_caliber} data={dataacaliber} 
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                    

                    <div className="tab-pane" id="bottom-tab2">
                          <div className="row"  id="listing-followup-groupby" >
            
                                <div className="col-sm-12" >
                                <div className="card card-table">
                                  <div className="card-body">
                                     
                                  <div className="table-responsive">

                                      <MaterialReactTable columns={columns} data={data} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                            ),
                                          ]}
                                        />
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>

                    </div>                             
                </div>
                )}
                </div>
            </div>
          
            </div>
           
           
        </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DailyProductionReports;
